import React, { Component } from 'react'
import loader from '../images/loader.svg'

class Loading extends Component {
	render() {
		return (
			<img
				alt=''
				src={loader}
				width={`${this.props.width + 'px' || '150px'}`}
				className='spinner'
			/>
		)
	}
}

export default Loading
